import { useNavigate } from 'react-router-dom'
import { useConnections } from 'features/connections/hooks/connectionsHooks'
import { useEffect } from 'react'
import useUserRoles from 'features/account/state/useUserRoles'

function SnowflakeCustomOnBoarding({ children }) {
  const navigate = useNavigate()
  const { userIsViewer } = useUserRoles()
  const { data: connections, isLoading } = useConnections()
  const emptyConnections = !isLoading && Boolean(!connections?.length)

  useEffect(() => {
    if (emptyConnections && !userIsViewer) {
      navigate('/sf/getting-started')
    }
  }, [isLoading, emptyConnections, userIsViewer, navigate])

  return children
}

export default SnowflakeCustomOnBoarding
